import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function TestimonialJulianaSection() {
  const scrollToPricing = () => {
    const section = document.getElementById('pricing');
    if (section) {
      section.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-6 md:py-10 bg-white" data-id="element-355">
      <div className="max-w-xl mx-auto px-5" data-id="element-356">
        <motion.h2 initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-xl md:text-2xl font-bold text-stone-900 text-center mb-6 tracking-[-0.02em]" data-id="element-357">
          Veja o que acontece quando uma artesã aplica o método:
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-3xl p-6 md:p-8 shadow-[0_2px_24px_-4px_rgba(0,0,0,0.06)] border border-stone-100/80" data-id="element-358">
          <div className="flex items-start gap-3 mb-4" data-id="element-359">
            <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 border-2 border-brand-100" data-id="element-360">
              <img src="https://cdn.magicpatterns.com/uploads/j8GQf97C6cmkmkpzoRLi9R/Gemini_Generated_Image_ks56wtks56wtks56.png" alt="Juliana" className="w-full h-full object-cover" data-id="element-361" />
            </div>
            <div data-id="element-362">
              <p className="font-bold text-stone-900 text-sm" data-id="element-363">Juliana</p>
              <p className="text-xs text-stone-400" data-id="element-364">Artesã, renda extra</p>
            </div>
          </div>

          <div className="relative" data-id="element-365">
            <Quote className="w-4 h-4 text-brand-300 mb-2" data-id="element-366" />
            <p className="text-sm md:text-[15px] text-stone-600 leading-relaxed italic tracking-[-0.01em]" data-id="element-367">
              Eu vendia meus potinhos a 5 reais e achavam caro. Apliquei o
              acabamento do guia e hoje vendo a 12 reais e a agenda vive
              cheia...
              <span className="text-stone-900 font-semibold not-italic" data-id="element-368">
                mudou meu negócio.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}